import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    formasPagamentos: [],
  },
  mutations: {
    carregar(state, formasPagamentos) {
      state.formasPagamentos = [];
      state.formasPagamentos = formasPagamentos;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/formas-pagamentos?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, formaPgtoInfo) {
      try {
        if (formaPgtoInfo.id == "") {
          var infoNovo = {
            descricao: formaPgtoInfo.descricao,
            codigo_nfe: parseInt(formaPgtoInfo.codigo_nfe),
          };
          await securedAxios.post("/formas-pagamentos", infoNovo);
        } else {
          var infoAltera = {
            descricao: formaPgtoInfo.descricao,
            codigo_nfe: parseInt(formaPgtoInfo.codigo_nfe),
          };
          await securedAxios.put(
            "/formas-pagamentos/" + formaPgtoInfo.id,
            infoAltera
          );
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarFormaPagamento(context, id) {
      return securedAxios.get(`/formas-pagamentos/${id}`);
    },
    carregarFormasPagamentos() {
      return securedAxios.get("/formas-pagamentos");
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete("/formas-pagamentos/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
